export const ADD_TIMER = 'ADD_TIMER'
export const REMOVE_TIMER = 'REMOVE_TIMER'
